module.exports = __webpack_public_path__ + "static/media/runcycle-small.ec964505.gif";